import React from "react";
import Top from "../../Top";
import Left from "../../Left";
import { useNavigate } from "react-router-dom";
import { Button, Grid } from "@mui/material";
// import DeleteIcon from "@mui/icons-material/Delete";

// For Modal
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import CloseIcon from "@mui/icons-material/Close";

import { makeGetRequest } from "../../../utils/utils";
import swal from "sweetalert";
// import * as Yup from "yup";
// import { Formik, Form } from "formik";

import AddSocietyAdmin from "./AddSocietyAdmin";
import AddSocietyNew from "./AddSocietyNew";
// End

import societyDummyPic from "../../../assets/Images/buildingDummyPic.jpg";

// const label = { inputProps: { "aria-label": "Size switch demo" } };

function AllSociety() {
  const navigate = useNavigate();

  // For memu
  // const [anchorEl, setAnchorEl] = React.useState(null);
  // const open2 = Boolean(anchorEl);
  // const handleClick = (event) => {
  //   setAnchorEl(event.currentTarget);
  // };
  // const handleClose2 = () => {
  //   setAnchorEl(null);
  // };
  // End

  // For Modal
  const [open, setOpen] = React.useState(false);
  const [scroll, setScroll] = React.useState("paper");

  const [societiesList, setSocietiesList] = React.useState([]);
  const [showLoader, setShowLoader] = React.useState(false);

  // const handleClickOpen = (scrollType) => () => {
  //   if (societiesList.length > 0) {
  //     setOpen(true);
  //     setScroll(scrollType);
  //   } else {
  //     swal("No Society Added !!", "Please Add Society", "warning");
  //   }
  // };

  const handleClose = () => {
    setOpen(false);
  };
  const descriptionElementRef = React.useRef(null);
  React.useEffect(() => {
    if (open) {
      const { current: descriptionElement } = descriptionElementRef;
      if (descriptionElement !== null) {
        descriptionElement.focus();
      }
    }
    localStorage.removeItem("societyName");
    GetAllSocieties();
  }, [open]);
  // End

  // For Modal
  const [open3, setOpen3] = React.useState(false);
  // const [scroll3, setScroll3] = React.useState("paper");

  // const [societiesList3, setSocietiesList3] = React.useState([]);

  const handleClickOpen3 = (scrollType) => () => {
    setOpen3(true);
    setScroll(scrollType);
  };
  const handleClose3 = () => {
    setOpen3(false);
  };
  // const descriptionElementRef3 = React.useRef(null);
  React.useEffect(() => {
    if (open3) {
      const { current: descriptionElement } = descriptionElementRef;
      if (descriptionElement !== null) {
        descriptionElement.focus();
      }
    }
    GetAllSocieties();
  }, [open3]);
  // End

  // const addCommitee = () => {
  //   var element = document.getElementById("successfullAdd");
  //   element.classList.toggle("hideModal");
  // };

  async function GetAllSocieties() {
    setShowLoader(true);
    await makeGetRequest("society/getall")
      .then((response) => {
        console.log(response);
        if (response.status == "201") {
          console.log(response.data.data);
          const data = response.data.data.rows;
          console.log(data);
          setSocietiesList(data);
          setShowLoader(false);
        } else {
          setShowLoader(false);
          swal("There was an error!", response.message, "warning");
        }
      })
      .catch((err) => {
        setShowLoader(false);
        swal("There was an error!", "more error details", "warning");
      });
  }

  async function handleSocietyRedirection(societyCode, schema, societyId) {
    setShowLoader(true);
    await makeGetRequest("society/getbysocietycode/" + societyCode)
      .then((response) => {
        console.log("Get By Society Code ", response.data.data.schema);
        if (response.status == "201") {
          if (response.data.data != undefined) {
            sessionStorage.setItem("schema", response.data.data.schema);

            localStorage.setItem("socityid", response.data.data.society_id);

            localStorage.setItem("societyName",response.data.data.society_name
            );
            localStorage.setItem("societyAddress", response.data.data.address);
            localStorage.setItem("societyCode", response.data.data.society_code);
            
            if (response.data.data.building_count == 0) {
              navigate("/BuildingYes");
            } else {
              localStorage.setItem(
                "buildingCnt",
                response.data.data.building_count
              );

              navigate("/Dashboard");
            }
          } else {
            console.log("In Else ");

            localStorage.setItem("socityid", "");
            localStorage.setItem("societyCode", societyCode);
            sessionStorage.setItem("schema", schema);
            swal("Success", "Society Not Configured Yet", "success", {
              timer: 1000,
              buttons: false,
            });
            navigate("/BuildingYes");
          }
        } 
        setShowLoader(false);
      })
      .catch((err) => {

        setShowLoader(false);

        swal("There was an error!", "more error details", "warning");
      });
    // navigate("/Dashboard")
  }

  return (
    <>
      <Top />
      {societiesList.length >= 1 ? <Left /> : <></>}
      <div className="rightContent">
        <Grid
          container
          spacing={3}
          className="mainHeadingLine AmenitiesOuterMain"
        >
          <Grid item xs={12} md={12} className="oneLineBt">
            <h1 className="panelHeading">All Society</h1>
            {/* <Button className="primaryBtn" onClick={handleClickOpen("body")}>
              Add Society Admin
            </Button> */}
          </Grid>

          <Grid item xs={12} md={12}>
            <div className="residentManagementTable">
              <div className="">
                <div className="bookAmiListNewInner">
                  <div className="bookAmiOut">
                    {societiesList.length > 0 ? (
                      <>
                        {societiesList.map((option, index) => (
                          <div
                            className="bookAmiImOut"
                            onClick={() =>
                              handleSocietyRedirection(
                                option.society_code,
                                option.schema,
                                option.society_id
                              )
                            }
                          >
                            {/* <div className="downLoDoqBt editIcoAllSociety">
                              <DeleteIcon />
                            </div> */}
                            <div className="bookAmiImg">
                              {option.society_image ? (
                                <img src={option.society_image} />
                              ) : (
                                <img src={societyDummyPic} />
                              )}
                            </div>
                            <p>{option.society_name}</p>
                          </div>
                        ))}
                      </>
                    ) : (
                      <div className="notConfiguredDiv">
                        <h1>No Society Configured yet</h1>
                      </div>
                    )}

                    <div className="addSocietyBottomBtOut">
                      <Button
                        className="primaryBtn"
                        onClick={handleClickOpen3("body")}
                      >
                        Add Society
                      </Button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Grid>
        </Grid>
      </div>

      {/* Add Society Admin */}
      <div className="modalMain">
        <Dialog
          open={open}
          // onClose={handleClose}
          scroll={scroll}
          aria-labelledby="scroll-dialog-title"
          aria-describedby="scroll-dialog-description"
        >
          <DialogTitle id="scroll-dialog-title" className="modalHeading">
            <span>Add Society Admin</span>
            <CloseIcon className="modalCloseBt" onClick={handleClose} />
          </DialogTitle>
          <DialogContent dividers={scroll === "paper"}>
            <div className="modalInnerCont">
              <AddSocietyAdmin />
            </div>
          </DialogContent>
        </Dialog>
      </div>

      {/* Add Society */}
      <div className="modalMain">
        <Dialog
          open={open3}
          // onClose={handleClose3}
          scroll={scroll}
          aria-labelledby="scroll-dialog-title"
          aria-describedby="scroll-dialog-description"
        >
          <DialogTitle id="scroll-dialog-title" className="modalHeading">
            <span>Add Society</span>
            <CloseIcon className="modalCloseBt" onClick={handleClose3} />
          </DialogTitle>
          <DialogContent dividers={scroll === "paper"}>
            <div className="modalInnerCont">
              <AddSocietyNew />
            </div>
          </DialogContent>
        </Dialog>
      </div>

      {showLoader ? (
        <div className="loaderOter" id="loaderId">
          <div className="wrapper">
            <div className="circle"></div>
            <div className="circle"></div>
            <div className="circle"></div>
            <div className="shadow"></div>
            <div className="shadow"></div>
            <div className="shadow"></div>
            <span>Loading</span>
          </div>
        </div>
      ) : (
        <></>
      )}
      
    </>
    
  );
}

export default AllSociety;
